export type CarrotPlanOptions = {
  menuOptions: CarrotPlanMenuItemCategory[]
  mediaOptions: CarrotPlanMediaCategory[]
}

export type CarrotPlanMenuItemCategory = {
  category: string
  menuItems: CarrotPlanMenuItem[]
}

interface CarrotPlanOption {
  optionMetadata: OptionMetadata
}

export type OptionMetadata = {
  isRecommended?: boolean
  recommendationPriority?: number
  displayStatus: DisplayStatus
  menuItemType?: MenuItemType
  isRequired?: boolean
  requiredNote?: string
  isPrioritized?: boolean
}

interface CarrotPlanMenuItem extends CarrotPlanOption {
  displayText: string
  defaultUrl: string
  entityId: string
}

export interface CarrotPlanMediaCategory extends CarrotPlanOption {
  entityId: string
  title: string
  subCategories: CarrotPlanMediaSubCategory[]
}

interface CarrotPlanMediaSubCategory extends CarrotPlanOption {
  entityId: string
  title?: string
  titleWithCategory?: string
  categoryTitle: string
  navTitle?: string | undefined
  mediaItems: CarrotPlanMediaItem[]
}

export interface CarrotPlanMediaItem extends CarrotPlanOption {
  entryId: string
  title?: string
  categoryTitle: string
  contentType: CarrotPlanMediaType
  slug?: string | undefined
  label?: string
  subCategory?: string
}

export enum CarrotPlanMediaType {
  Article = "article",
  Video = "video",
  Guide = "guide",
  Group = "groupSession"
}

export enum DisplayStatus {
  UNASSIGNED = "UNASSIGNED",
  SHOW = "SHOW",
  DISABLE = "DISABLE",
  WARNING_ON_PREVIOUS_CARROT_PLAN = "WARNING_ON_PREVIOUS_CARROT_PLAN",
  WARNING_ALREADY_ANSWERED_MEDICAL_QUESTIONS = "WARNING_ALREADY_ANSWERED_MEDICAL_QUESTIONS",
  ARCHIVED = "ARCHIVED",
  REMOVE = "REMOVE"
}

export enum MenuItemType {
  UNASSIGNED = "UNASSIGNED",
  PERSONAL_INTERACTION = "PERSONAL_INTERACTION",
  SELF_SERVE_RESOURCE = "SELF_SERVE_RESOURCE",
  FINANCIAL_INFORMATION = "FINANCIAL_INFORMATION"
}

export type CarrotPlanRecommendation = {
  menuItemId: string
  mediaItemId?: string | null
  tier: ContentTier
}

const ContentTier = {
  Required: "Required",
  Recommended: "Recommended",
  Requested: "Requested",
  Relevant: "Relevant",
  StageMatched: "StageMatched",
  AllJourneys: "AllJourneys",
  JourneyMatched: "JourneyMatched",
  OtherJourney: "OtherJourney",
  Excluded: "Excluded",
  AlreadyAssigned: "AlreadyAssigned"
} as const

export type ContentTier = typeof ContentTier[keyof typeof ContentTier]
